<template>
    <actions-layout-content :title="$t('pages.error.not_found.status_no')">
        <template #subtitle>{{ $t('pages.error.not_found.name') }}</template>
        <template #content>
            <common-content-wrapper width="medium">
                <common-message>
                    {{ $t('pages.error.not_found.message') }}
                </common-message>
            </common-content-wrapper>
        </template>
    </actions-layout-content>
</template>

<script>
    import ActionsLayoutContent from 'components/layouts/layout-content/ActionsLayoutContent'
    export default {
        components: { ActionsLayoutContent },
    }
</script>
